import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

import Loader from "../Loader";
import styles from "./button.module.scss";

const Button = ({
  type = "button",
  size,
  theme,
  color,
  disabled,
  loading,
  to,
  onClick,
  children,
}) => {
  const handleOnClick = (e) => {
    onClick && !loading && !disabled && onClick(e);
  };

  const loaderSize = () => {
    return {
      "sm-square": 10,
      sm: 10,
      "md-square": 12,
      md: 12,
      "lg-square": 20,
      lg: 20,
    }[size];
  };

  const className = [
    styles.wrap,
    styles[size],
    styles[theme],
    styles[color],
    loading && styles.loading,
  ]
    .filter(Boolean)
    .join(" ");

  const loaderClassName = [styles.loader, loading && styles.active]
    .filter(Boolean)
    .join(" ");

  const Component = to ? Link : "button";

  return (
    <Component
      className={className}
      type={type}
      to={to}
      disabled={disabled}
      onClick={handleOnClick}
    >
      {typeof children === "string" ? <p>{children}</p> : children}
      {loading && (
        <span className={loaderClassName}>
          <Loader
            color={color === "primary" ? "white" : "primary"}
            size={loaderSize()}
            noPd
          />
        </span>
      )}
    </Component>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  size: PropTypes.oneOf([
    "sm-square",
    "md-square",
    "lg-square",
    "sm",
    "md",
    "lg",
  ]),
  theme: PropTypes.oneOf(["transparent", "bordered", "filled"]),
  color: PropTypes.oneOf([
    "white",
    "light",
    "primary",
    "success",
    "error",
    "warning",
    "info",
  ]),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Button.defaultProps = {
  size: "sm",
  color: "white",
  disabled: false,
  children: null,
};

export default Button;
